import { SxProps } from "@mui/material";

export const sxLabel: SxProps = {
    color: '#383838',
    fontWeight: 600,
    marginBottom: '16px'
}

export const sxBoxChevron: SxProps = {
    padding: '15px 20px 15px 20px'
}